module.exports = __webpack_public_path__ + "img/gsgc2902_2.3456d859.svg";